const damageSourceOptions = [
  { id: 1, value: 'Yes' },
  { id: 2, value: 'No' },
];

export { damageSourceOptions };
